import { render, staticRenderFns } from "./input-folders-dropdown.vue?vue&type=template&id=21cf77fb&"
import script from "./input-folders-dropdown.vue?vue&type=script&lang=js&"
export * from "./input-folders-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./input-folders-dropdown.vue?vue&type=style&index=0&id=21cf77fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports